import { render, staticRenderFns } from "./FireOutbreakCardReactionMenu.vue?vue&type=template&id=a48c47e4"
import script from "./FireOutbreakCardReactionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./FireOutbreakCardReactionMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports